import {
	IdPCommonInputFieldName,
	MdComponentNames,
	TIdPInputField
} from 'consts';
import { IMethodGuide } from 'types/api';
import { TMethodGuideFieldsInfo } from 'types/fields';

export const extractStepFields = (stepContent: string) =>
	Array.from(
		stepContent.matchAll(/(<IdPInputField[A-z0-9 =()"\-./]*\/>)/g)
	).map((inputField) => {
		const fieldNameExecRes = /fieldName="([A-z0-9-]*)"/.exec(inputField[1]);
		const [, fieldName] = fieldNameExecRes || [];
		const displayNameExecRes = /displayName="([A-z0-9 .\-()]*)"/.exec(
			inputField[1]
		);
		const [, displayName] = displayNameExecRes || [];

		return { fieldName: fieldName as TIdPInputField, displayName };
	});

export const extractGuideFieldsInfo = (methodGuide: IMethodGuide) => {
	const res: TMethodGuideFieldsInfo = {};
	for (let i = 0; i < (methodGuide?.guide.length || 0); i++) {
		const step = methodGuide?.guide[i]!;
		for (const fieldInfo of extractStepFields(step.content)) {
			res[fieldInfo.fieldName] = { ...fieldInfo, stepNum: i + 1 };
		}
		// eslint-disable-next-line security/detect-non-literal-regexp
		const userAttributesRegex = new RegExp(
			`<${MdComponentNames.UserAttributes}[A-z0-9 =()".\\-/]*\\/?>`,
			'g'
		);
		const match = step.content.match(userAttributesRegex);
		if (match) {
			res[IdPCommonInputFieldName.UserAttributes] = {
				displayName: intl.tr('ssoConfig.fields.userAttributesFieldName'),
				stepNum: i + 1
			};
		}
		// eslint-disable-next-line security/detect-non-literal-regexp
		const groupsAttributeRegex = new RegExp(
			`<${MdComponentNames.GroupsAttribute}[A-Za-z0-9 =()".\\-/]*\\/?>`,
			'g'
		);
		const groupsMatch = step.content.match(groupsAttributeRegex);
		if (groupsMatch) {
			res[IdPCommonInputFieldName.GroupsAttribute] = {
				displayName: intl.tr('ssoConfig.fields.groupsAttributeNameFieldLabel'),
				stepNum: i + 1
			};
		}
	}

	return res;
};
